// SettingsComponents.js
import React from "react";
import { Box, Typography } from "@mui/material";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useNavigate } from "react-router-dom";

import {
  PageContainer,
  SettingsTitleWrap,
  CardContainer,
  OptionCard,
  OptionIconWrapper,
} from "./Styles";

function SettingsComponents() {
  const navigate = useNavigate();

  return (
    <PageContainer>
      <SettingsTitleWrap sx={{ mb: 4 }}>
        <Typography
          sx={{
            fontFamily: "Plus Jakarta Sans",
            fontSize: "26px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "140%",
          }}
        >
          Settings
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Manage payment rules and company entities.
        </Typography>
      </SettingsTitleWrap>

      <CardContainer>
        {/* Company entities */}
        <OptionCard
          onClick={() => navigate("/admin/settings/company-entities")}
          sx={{ cursor: "pointer" }}
        >
          <Box display="flex" alignItems="center" gap={2}>
            <OptionIconWrapper>
              <MailOutlineIcon fontSize="small" />
            </OptionIconWrapper>

            <Box>
              <Typography variant="subtitle1" fontWeight={600}>
                Company entities
              </Typography>
              <Typography variant="body2" color="text.secondary" mt={0.5}>
                View, create, and edit your company entities.
              </Typography>
            </Box>
          </Box>

          <ChevronRightIcon sx={{ color: "text.disabled" }} />
        </OptionCard>

        {/* Payment rules */}
        <OptionCard
          onClick={() => navigate("/admin/settings/payment-rules")}
          sx={{ cursor: "pointer" }}
        >
          <Box display="flex" alignItems="center" gap={2}>
            <OptionIconWrapper>
              <Typography variant="subtitle2" fontWeight={700}>
                ***
              </Typography>
            </OptionIconWrapper>

            <Box>
              <Typography variant="subtitle1" fontWeight={600}>
                Payment rules
              </Typography>
              <Typography variant="body2" color="text.secondary" mt={0.5}>
                Control how Broker and IB payments are handled across your
                organization.
              </Typography>
            </Box>
          </Box>

          <ChevronRightIcon sx={{ color: "text.disabled" }} />
        </OptionCard>
      </CardContainer>
    </PageContainer>
  );
}

export default SettingsComponents;
